export const GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:device_code';

export const ERROR_AUTHORIZATION_PENDING = 'authorization_pending';

export const ERROR_SLOW_DOWN = 'slow_down';
